import { render } from "./CommentsComponent.vue?vue&type=template&id=1c8278f6"
import script from "./CommentsComponent.vue?vue&type=script&lang=js"
export * from "./CommentsComponent.vue?vue&type=script&lang=js"

import "./CommentsComponent.vue?vue&type=style&index=0&id=1c8278f6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__